@switch ((status ?? '').toString().toUpperCase()) {
  @case (MensagemStatusEnum.SENT) { <mat-icon>check</mat-icon> }
  @case (MensagemStatusEnum.DELIVERED) { <mat-icon>done_all</mat-icon> }
  @case (MensagemStatusEnum.READ) { <mat-icon class="status-lida">done_all</mat-icon> }
  @case (MensagemStatusEnum.FAILED) { <mat-icon class="status-erro">error</mat-icon> }
}
